import React, { useRef, useState } from 'react';

import { Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Modals.scss';
import { Container, i18n } from '../../../../symphony';
import { SlModal } from '../../../../shared/public/SlModal/SlModal';
import { lePlaygroundContext, tiyCodeInputModalId } from '../../global-constants';
import { CodeLanguages } from '../../../../api/public/global';
import { SlDataService } from '../../services/sl-data.service';
import { SlEventsService } from '../../services/Business/sl-events.service';

export function ModalForLanguageInputs(): JSX.Element {
	useStyles(s);
	const textareaRef = useRef<HTMLTextAreaElement>(null);
	const [inputsValue, setInputsValue] = useState<string>('');

	const onInputChange = (input: string): void => {
		setInputsValue(input);
	};

	const handleSubmitBtnPress = (): void => {
		const eventsService = Container.take(lePlaygroundContext.value, SlEventsService);

		const {
			codeData$,
		} = Container.take(lePlaygroundContext.value, SlDataService);

		eventsService.onModalRunBtnClick(codeData$.value?.language === CodeLanguages.R ? `${inputsValue}\n` : inputsValue);
	};

	return (
		<SlModal id={tiyCodeInputModalId}>
			<div className="sl-tiy-inputs-modal" onKeyDown={(e) => e.stopPropagation()}>
				<h3 className="sl-tiy-inputs-modal__title">
					{i18n.t('code.input.title')}
				</h3>
				<p className="sl-tiy-inputs-modal__sub-title">{i18n.t('code.input.subtitle')}</p>
				<textarea
					onInput={(e: any) => {
						e.target.style.height = '78px';
						e.target.style.height = `${e.target.scrollHeight + 2}px`;
					}}
					maxLength={100}
					ref={textareaRef}
					className="sl-tiy-inputs-modal__input"
					value={inputsValue}
					onChange={(event) => onInputChange(event.target.value)}
				/>
				<span className="sl-tiy-inputs-modal__input-length">
					{inputsValue.length}
					/100
				</span>
				<Button
					disabled={!inputsValue.length}
					onClick={handleSubmitBtnPress}
				>
					{i18n.t('common.submit-action-title')}
				</Button>
			</div>
		</SlModal>
	);
}
